/* global $ */

let lastUrl = null;
module.exports = [
    {
        type: "navigation", //called on navigation
        interceptor: function (app, context, next){

            next() ;  //don't stop the flow

            setTimeout(()=>{
                if(lastUrl !== location.href){
                    lastUrl = location.href;
                    const element = document.querySelector(".qr-code") ;
                    if(element){
                        new window.QRious({
                            foreground: '#777',
                            size: 150,
                            element: element,
                            value: location.href,
                        }) ;
                    }
                }
            }, 500) ;
        }
    }
];